import { render, staticRenderFns } from "./RTB.vue?vue&type=template&id=3db52112"
import script from "./RTB.vue?vue&type=script&lang=js"
export * from "./RTB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports